<template>
  <section
    :class="['content-tip', gameName]"
    v-if="isRenderTemp"
    :style="moduleBackColor"
  >
    <p :style="mFontColor" class="tip text-tip">{{ contentText }}</p>
    <div class="btn-group">
      <button class="btn-tip" @click="toRedeem" v-if="isCodeRedeemUrl">
        {{ $t('publicDetails.games_order_btn1') }}
      </button>
      <button class="btn-tip" @click="toOrder">
        {{ $t('publicDetails.games_order_btn2') }}
      </button>
    </div>
  </section>
</template>
<script>
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { mapState, mapGetters } from 'vuex'
  import { order_check, midas_redeem } from '../../firebase'
  import { tryToNative, changeTitleBarMode } from '@/utils/native'
  import { urlAddNotNullParams } from '@/utils/url'
  import { jumpToPage } from '@/utils/utils'

  export default {
    mixins: [styleConfiguration],
    computed: {
      ...mapState(['gameName', 'region']),
      ...mapState('detail', ['detailBasicConfig']),
      ...mapGetters(['appBaseUrl']),
      ...mapGetters('detail', ['isCodeRedeemUrl']),
      isRenderTemp() {
        return this.awardType !== 2 && this.uidModuleType !== 6
      },
      showTipsName() {
        const showName = this.detailBasicConfig?.gameShowDetail?.showName
        return showName || this.gameName
      },
      contentText() {
        return this.$t('publicDetails.games_order_title', {
          gameName: this.showTipsName,
        })
      },
    },
    methods: {
      toOrder() {
        order_check(this.gameName)
        // 跳转至订单页
        tryToNative({
          url: 'order',
          params: JSON.stringify({
            requireLogin: true,
            url: urlAddNotNullParams(`${this.appBaseUrl}/order`, {
              ...this.$route.query,
              type: 'contact_us',
            }),
          }),
        }).catch(() =>
          this.$router_push({
            path: `/order`,
            query: {
              ...this.$route.query,
              type: 'contact_us',
            },
          })
        )
      },
      toRedeem() {
        midas_redeem(this.gameName)
        // 跳转至米大师
        if (this.isApp) {
          changeTitleBarMode(0)
        }

        if (this.isCodeRedeemUrl) {
          jumpToPage(this.isCodeRedeemUrl, 'open')
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .content-tip {
    margin: 0 21px 20px 21px;
    padding: 20px 26px;
    background: #303840;
    border-radius: 22px;
    &.tinder {
      background: rgb(255, 255, 255);
      .text-tip {
        color: rgb(64, 69, 75);
      }
    }
    .tip {
      margin-bottom: 30px;
    }
    p {
      font-size: 36px;
      line-height: 1.3;
      font-style: normal;
    }
    .text-tip {
      font-size: 42px;
      line-height: 1.25;
      font-weight: bold;
      color: #ffffff;
    }
    .btn-group {
      display: flex;
    }
    .btn-tip {
      &:not(:first-child) {
        margin-left: 36px;
      }
      font-size: 36px;
      line-height: 1.3;
      font-weight: bold;
      color: #ff792e;
      border: 3px solid #ff792e;
      box-sizing: border-box;
      border-radius: 45px;
      padding: 13px 42px;
      display: block;
    }
  }
</style>
